$(document).ready( function() {
  "use strict";

  changeInquiryButtonLink();
  openInquiryModal();
  openInquiryModalAfterQuickViewModal();
  submitInquiryModal();
  removeInquiryModal();
  toggleProductVariantFormButtons();
  toggleProductVariantFormButtonsOnModal();
});

function inquiryModalAjax(element) {
  var url = element.attr('data-url');

  $.ajax({
    method: 'GET',
    url: url,
  }).done(function (data) {
    $('footer').after(data.html);
    $('#product-inquiry').modal('show');
  });
}

function openInquiryModal() {
  $('.product-inquiry-btn').on('click', function () {
    inquiryModalAjax($(this));
  });
}

function openInquiryModalAfterQuickViewModal() {
  $('body').on('click', '#quick-view-product-modal .product-inquiry-btn', function () {
    var element = $(this);

    $('#quick-view-product-modal').modal('hide');
    $('#quick-view-product-modal').on('hidden.bs.modal', function () {
      inquiryModalAjax(element);
    });
  });
}

function submitInquiryModal() {
  $('body').on('submit', '#product-inquiry form', function (e) {
    e.preventDefault();

    var currentForm = $(this);
    var formContainer = currentForm.parent();

    $.ajax({
      type: $(this).attr('method'),
      url: $(this).attr('action'),
      data: $(this).serialize(),
      dataType: "json"
    })
      .done(function (data) {
        currentForm.remove();
        formContainer.prepend(data.html);
      });
  });
}

function removeInquiryModal() {
  $('body').on('hidden.bs.modal', '#product-inquiry', function (e) {
    e.currentTarget.remove();
  });
}

function changeInquiryButtonLink(modal = false) {
  var $inquiryButton = $('#sylius-product-adding-to-cart .product-inquiry-btn');
  if ($inquiryButton.length > 0) {
    var inquiryButtonUrl = $inquiryButton.data('url');
    var inquiryModalWithoutVariantUrl = inquiryButtonUrl.split("?");
    $('[name="sylius_add_to_cart[cartItem][variant]"]').on('change', function () {
      var variantCode = $(this).val();
      inquiryButtonUrl = inquiryModalWithoutVariantUrl[0].concat('?variant_code=').concat(variantCode);
      $inquiryButton.attr('data-url', inquiryButtonUrl);

      toggleProductVariantFormButtons(modal);
    });
  }
}

function toggleProductVariantFormButtons(modal = false) {
  var variantsElement = modal ? '#quick-view-product-modal #sylius-product-variants' : '#sylius-product-variants';
  var addingToCartElement = modal ? '#quick-view-product-modal #sylius-product-adding-to-cart' : '#sylius-product-adding-to-cart';
  if ($(variantsElement).length > 0) {
    var $checkedElement = $('input[name="sylius_add_to_cart[cartItem][variant]"]:checked', addingToCartElement);
    var checkedElementPriceFrom = Boolean(Number($checkedElement.attr('data-price-from')));

    if (checkedElementPriceFrom) {
      $(addingToCartElement + ' .iso-df-spinner').hide();
      $(addingToCartElement + ' .iso-df-btn-add-to-cart').hide();
      $(addingToCartElement + ' .product-inquiry-btn').show();
    } else {
      $(addingToCartElement + ' .iso-df-spinner').show();
      $(addingToCartElement + ' .iso-df-btn-add-to-cart').show();
      $(addingToCartElement + ' .product-inquiry-btn').hide();
    }
  }
}

function toggleProductVariantFormButtonsOnModal() {
  $('body').on('shown.bs.modal', '#quick-view-product-modal', function () {
    toggleProductVariantFormButtons(true);
    changeInquiryButtonLink(true);
  });
}
